import React, { useState } from 'react';
import Validator from 'validatorjs';
import { Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../facturotopia';

const TotalesForm = (props) => {
  const [, setValidator] = useState({
    isValid: false,
    validator: new Validator(),
  });

  const getRules = (data) => {
    let ruleClaveRet = 'string';

    if (props.original.CveRetenc === '28') {
      ruleClaveRet = 'required';
    }

    return {
      MontoTotOperacion: ['required', 'numeric', 'min:0.00', 'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/'],
      MontoTotGrav: ['required', 'numeric', 'min:0.00', 'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/'],
      MontoTotExent: ['required', 'numeric', 'min:0.00', 'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/'],
      MontoTotRet: ['required', 'numeric', 'min:0.00', 'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/'],
      UtilidadBimestral: [ruleClaveRet, 'numeric', 'min:0.00', 'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/'],
      ISRCorrespondiente: [ruleClaveRet, 'numeric', 'min:0.00', 'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/'],
    };
  };

  const handleOnChange = (event) => {
    const data = {
      ...props.data,
      ...event,
    };

    const validator = validate(data);

    props.onFormDataChange(data, {
      name: 'isValidTotales',
      isValid: validator.passes(),
    });
  };

  const validate = (data) => {
    const validator = new Validator(data, getRules(data));

    validator.check();

    setValidator({
      validator,
      isValid: validator.passes(),
    });

    return validator;
  };

  const { data = {}, original = {} } = props;

  const disabled = original.CveRetenc === '28';

  const rules = getRules(data);

  return (
    <Row>
      <Col
        sm
        md={3}
      >
        {/* El valor de este atributo debe ser igual a la suma de los atributos MontoTotGrav y MontoTotExent. */}
        <FormControl
          type="number"
          label="Total operación"
          name="MontoTotOperacion"
          placeholder=""
          help="Debe ser Total gravado + Total exento"
          rules={rules.MontoTotOperacion}
          value={data.MontoTotOperacion}
          onChange={handleOnChange}
        />
      </Col>

      {/* El valor de este atributo debe ser menor o igual al atributo MontoTotOperacion. */}
      <Col
        sm
        md={3}
      >
        <FormControl
          type="number"
          label="Total gravado"
          name="MontoTotGrav"
          placeholder=""
          help=""
          disabled={disabled}
          rules={rules.MontoTotGrav}
          value={disabled ? 0 : data.MontoTotGrav}
          onChange={handleOnChange}
        />
      </Col>
      {/* El valor de este atributo debe ser menor o igual al atributo MontoTotOperacion. */}
      <Col
        sm
        md={3}
      >
        <FormControl
          type="number"
          label="Total exento"
          name="MontoTotExent"
          placeholder=""
          help=""
          disabled={disabled}
          rules={rules.MontoTotExent}
          value={disabled ? 0 : data.MontoTotExent}
          onChange={handleOnChange}
        />
      </Col>

      {/* Si el valor es mayor que cero, debe existir al menos un nodo hijo de ImpRetenidos y debe ser igual a la suma de los atributos MontoRet. */}
      <Col
        sm
        md={3}
      >
        <FormControl
          type="number"
          label="Total retenciones"
          name="MontoTotRet"
          placeholder=""
          help=""
          rules={rules.MontoTotRet}
          value={data.MontoTotRet}
          onChange={handleOnChange}
        />
      </Col>

      {/* Si el valor registrado en el atributo CveRetenc es “28”, el valor de este atributo debe ser mayor a cero y los atributos MontoTotGrav y MontoTotExento deben tener el valor “0”. */}

      <Col
        sm
        md={3}
      >
        <FormControl
          type="number"
          label="Utilidad bimestral"
          name="UtilidadBimestral"
          placeholder=""
          help=""
          rules={rules.UtilidadBimestral}
          value={data.UtilidadBimestral}
          onChange={handleOnChange}
        />
      </Col>

      {/* Si el valor registrado en el atributo CveRetenc es “28”, el valor de este atributo debe ser mayor a cero y los atributos MontoTotGrav y MontoTotExento deben tener el valor “0”. */}
      <Col
        sm
        md={3}
      >
        <FormControl
          type="number"
          label="ISR correspondiente"
          name="ISRCorrespondiente"
          placeholder=""
          help=""
          rules={rules.ISRCorrespondiente}
          value={data.ISRCorrespondiente}
          onChange={handleOnChange}
        />
      </Col>
    </Row>
  );
};

export default TotalesForm;
